import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { AppStorageService } from '../../services/app-storage.service';
import { StorageKeys } from '../../services/storage-keys';

export const AuthGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const utilsService = inject(UtilsService);
  const storage = inject(AppStorageService);

  if (authService.isAuthenticated()) {
    return true;
  }

  const isWeb = await utilsService.detectIsWeb();

  storage.set(StorageKeys.REDIRECT_URL, window.location.pathname);

  router.navigate([!isWeb ? '/selection' : '/login']);
  return false;
};
